import { Action } from '@/_core/fluxstore/types';
import { AppLoaderState } from '../types';
import { useAppLoaderModule } from '..';

const { registerReducer } = useAppLoaderModule();

export class CloseAppLoader extends Action<AppLoaderState> {
    public static ACTION_TYPE = 'CloseAppLoader';

    public constructor() {
        super(CloseAppLoader.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer = (state: AppLoaderState, action: CloseAppLoader): void => {
    state.isLoading = false;
};

//@ts-ignore
registerReducer(CloseAppLoader.ACTION_TYPE, reducer);
